module.exports = __webpack_public_path__ + "static/Panda1-c18879fbc39ea5b5cfebcaf648eb432f.svg";